/**
 * The quotes module's assistant views (design D18), registered in
 * `registry.ts` like `crmAgentViews`: `quote_preview`, the read-only
 * replica of a quote the assistant shows before the user confirms it.
 */
import { Alert } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { QuotePreviewView } from "./QuotePreviewView.js";
import { isQuotePreviewView } from "./quotePreviewSpec.js";
import type { AgentViewComponent } from "./registry.js";
import { WizardQuestionView } from "./WizardQuestionView.js";
import { isWizardQuestionView } from "./wizardQuestionSpec.js";

export const QuotePreviewAgentView: AgentViewComponent = ({ view }) => {
  if (!isQuotePreviewView(view)) return null;
  return <QuotePreviewView view={view} />;
};

/** A malformed stored spec renders a single generic warning, like the core views. */
export const WizardQuestionAgentView: AgentViewComponent = ({
  view,
  onSend,
  busy,
  answeredWith,
}) => {
  if (!isWizardQuestionView(view)) return <MalformedWizardQuestion />;
  return (
    <WizardQuestionView
      view={view}
      onSend={onSend}
      busy={busy}
      answeredWith={answeredWith}
    />
  );
};

const MalformedWizardQuestion = () => {
  const { t } = useTranslate("Assistant");
  return (
    <Alert severity="warning" sx={{ py: 0, my: 0.5 }}>
      {t("Question could not be shown")}
    </Alert>
  );
};

export const quotesAgentViews: Record<string, AgentViewComponent> = {
  quote_preview: QuotePreviewAgentView,
  wizard_question: WizardQuestionAgentView,
};
